import React from 'react';

function DrivePathModal({ show, escola, value, onChange, onSave, onClose, saving }) {
  if (!show) return null;
  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', position: 'fixed', zIndex: 1055 }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg rounded-4">
          <div className="modal-header bg-success text-white py-2 rounded-top-4">
            <h5 className="modal-title m-0 fw-bold">Adicionar Documentos</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">CNPJ</label>
              <input type="text" className="form-control" value={escola?.cnpj || ''} readOnly />
            </div>
            <div className="mb-3">
              <label className="form-label">Nome da Escola</label>
              <input type="text" className="form-control" value={escola?.nome || ''} readOnly />
            </div>
            <div className="mb-3">
              <label className="form-label">Drive Path</label>
              <input type="text" className="form-control" value={value} onChange={onChange} maxLength={255} required autoFocus />
            </div>
          </div>
          <div className="modal-footer bg-light rounded-bottom-4">
            <button type="button" className="btn btn-secondary rounded-pill px-4" onClick={onClose} disabled={saving}>Cancelar</button>
            <button type="button" className="btn btn-success rounded-pill px-4" onClick={onSave} disabled={saving || !value}>Salvar</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DrivePathModal;
